import { render, staticRenderFns } from "./Accreditation.vue?vue&type=template&id=3e49acb9&scoped=true"
import script from "./Accreditation.vue?vue&type=script&lang=js"
export * from "./Accreditation.vue?vue&type=script&lang=js"
import style0 from "./Accreditation.vue?vue&type=style&index=0&id=3e49acb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49acb9",
  null
  
)

export default component.exports